import { useContext } from "react";
import { ObjectSchema, number, object } from "yup";
import { AvisConstants } from "../../../../data/avisConstants";
import { InvoiceListInfo } from "../../../../generated/data-contracts";
import { IFilterProps } from "../../../../models";
import { api, IAxiosError, LicenseesUtils } from "../../../../utils";
import { AvisFilterableTable } from "../../../shared/components/table";
import { AvisContext } from "../../../shared/context/AvisContext";
import { columnConfigInvoices } from "../columnConfigInvoices";

interface IInvoicesArchiveGridProps {
  setError: React.Dispatch<React.SetStateAction<IAxiosError | undefined>>;
}
export function InvoicesArchiveGrid(
  props: Readonly<IInvoicesArchiveGridProps>,
) {
  const { setError } = props;
  const { res } = useContext(AvisContext);

  const licenseId = LicenseesUtils.getUrlParams().licenseId;

  const columnMetadata = columnConfigInvoices(true, res);
  const validationSchema: ObjectSchema<IFilterProps> = object({
    pageIndex: number().min(0),
    pageSize: number().min(1),
  });

  return (
    <AvisFilterableTable<InvoiceListInfo, IFilterProps>
      defaultFilterValues={{ pageIndex: 0, pageSize: 10 }}
      filterSessionKey={AvisConstants.invoices_archive_filter_values_key}
      filterValidationSchema={validationSchema}
      setError={setError}
      getApiData={(filter) => {
        return licenseId
          ? api.licenseesGetInvoiceArchiveForLicense(licenseId, filter as any)
          : api.licenseesGetInvoiceArchive(filter as any);
      }}
      renderFilter={() => <></>}
      tableColumns={columnMetadata}
      tableColumnWidths={[20, 50, 30]}
    />
  );
}
